import React, { useState } from "react";
import styled from "styled-components";
import InputBox from "./InputBox";

const InputWrapper = styled.div`
	position: relative;
	width: ${(props) => (props.fullWidth ? "100%" : "auto")};
`;

const ErrorMessage = styled.span`
	color: #ef4444;
	font-size: 0.875rem;
	margin-top: 0.25rem;
	display: block;
`;

const DecimalInput = ({
	onChange,
	defaultValue = "",
	fullWidth = false,
	disabled = false,
	min = undefined,
	max = undefined,
	...props
}) => {
	const [value, setValue] = useState(defaultValue);
	const [error, setError] = useState("");

	const validateValue = (numValue) => {
		// Only validate if min is explicitly provided
		if (min !== undefined && numValue < min) {
			// setError(`Value must be greater than or equal to ${min}`);
			return false;
		}
		// Only validate if max is explicitly provided
		if (max !== undefined && numValue > max) {
			// setError(`Value must be less than or equal to ${max}`);
			return false;
		}
		setError("");
		return true;
	};

	const handleChange = (e) => {
		const inputValue = e.target.value;

		// Allow empty input
		if (inputValue === "") {
			setValue("");
			onChange("");
			setError("");
			return;
		}

		// Regex to match numbers with up to 2 decimal places
		const regex = /^\d*\.?\d{0,2}$/;

		if (regex.test(inputValue)) {
			// Convert to number and validate
			const numValue = parseFloat(inputValue);
			if (!isNaN(numValue)) {
				if (validateValue(numValue)) {
                    setValue(inputValue);
					onChange(numValue); // Passing number instead of string
				}
			}
		}
	};

	// Validate initial value
	React.useEffect(() => {
		if (defaultValue) {
			const numValue = parseFloat(defaultValue);
			if (!isNaN(numValue)) {
				validateValue(numValue);
			}
		}
	}, [defaultValue, min, max]);

	// Generate placeholder text based on min/max constraints
	const getPlaceholder = () => {
		if (min !== undefined && max !== undefined) {
			return `Enter number (${min}-${max})`;
		} else if (min !== undefined) {
			return `Enter number (min: ${min})`;
		} else if (max !== undefined) {
			return `Enter number (max: ${max})`;
		}
		return "Enter number (max 2 decimals)";
	};

	return (
		<InputWrapper fullWidth={fullWidth}>
			<InputBox
				type="text"
				value={value}
				onChange={handleChange}
				disabled={disabled}
				hasError={!!error}
				placeholder={props.placeholder || getPlaceholder()}
				{...props}
			/>
			{error && <ErrorMessage>{error}</ErrorMessage>}
		</InputWrapper>
	);
};

export default DecimalInput;
